import React from "react";
import styled from "styled-components";
import { Translation, t } from "../../../core/translate";
import { Button, Dialog } from "@vitalsource/vstui";
import { downloadApp, launchInApp } from "../../../utils/read-offline";
import { styledLargeMobileMediaQuery } from "../../../components/mediaquery/breakpoints";

const Styled = {
  Container: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    > * {
      :not(:last-child) {
        margin-bottom: 15px;
      }
    }
  `,
  BestExperience: styled.div`
    font-size: 3rem;
    font-weight: bold;
  `,
  FeaturesArentAvailable: styled.div`
    ${styledLargeMobileMediaQuery`
        display: none;
      `}
  `,
  OpenAppButton: styled(Button)`
    border-radius: 24px;
    ${styledLargeMobileMediaQuery`
        width: 342px;
        font-size: 1.8rem;
      `}
  `,
  NotNowButton: styled(Button)`
    ${styledLargeMobileMediaQuery`
        font-size: 1.6rem;
      `}
  `
};

class DownloadAppUI extends React.Component {
  constructor() {
    super();

    this.state = {
      openLaunchingAppDialog: false
    };
  }

  closeLaunchingAppModal() {
    this.setState({ openLaunchingAppDialog: false });
  }

  render() {
    return (
      <Styled.Container>
        <Styled.BestExperience id="dialog-alert-title">
          <Translation id="native.best-experience">
            Get the best experience with the app!
          </Translation>
        </Styled.BestExperience>
        <Styled.FeaturesArentAvailable id="dialog-alert-message">
          <Translation id="native.simplified">
            We’ve simplified the mobile browser experience. Access all features
            through the app!
          </Translation>
        </Styled.FeaturesArentAvailable>
        <Styled.OpenAppButton
          pill
          color="white"
          onClick={() => {
            this.setState({ openLaunchingAppDialog: true });
            Fraction.Reporter.noticeInteraction("interstitial-open-app");
            launchInApp();
          }}
        >
          <Translation id="native.open-app">Open App</Translation>
        </Styled.OpenAppButton>
        <Styled.NotNowButton
          naked
          color="white"
          onClick={() => {
            Fraction.Reporter.noticeInteraction("interstitial-not-now");
            this.props.continueToMobileSite();
          }}
        >
          <Translation id="base.not-now">Not Now</Translation>
        </Styled.NotNowButton>
        <Dialog
          title={t(
            "native.launching-app-on-device",
            "Launching App on your device..."
          )}
          open={this.state.openLaunchingAppDialog}
          requireInteraction
          alert
          onRequestClose={() => this.closeLaunchingAppModal()}
          primaryActionButton={{
            label: t("base.download", "Download"),
            onClick: e => {
              Fraction.Reporter.noticeInteraction("download-app-launch-app");
              downloadApp(e);
            }
          }}
          secondaryActionButton={{
            label: t("base.cancel", "Cancel"),
            onClick: () => this.closeLaunchingAppModal()
          }}
        >
          <Translation id="native.nothing-happening">
            If nothing is happening, you might not have the app downloaded or ad
            blockers may be enabled.
          </Translation>
        </Dialog>
      </Styled.Container>
    );
  }
}

export default DownloadAppUI;
